const LayoutDefault = () =>
  import(/* webpackChunkName: "sc" */ '@/layouts/LayoutDefault.vue');
const LayoutData = () =>
  import(/* webpackChunkName: "sc" */ '@/layouts/LayoutData.vue');
const Dashboard = () =>
  import(
    /* webpackChunkName: "sc" */ '@/views/stockist-center/penjualan/dashboard/Index.vue'
  );

// Transaksi Penjualan
const TransaksiPenjualan = () =>
  import(
    /* webpackChunkName: "sc" */ '@/views/stockist-center/penjualan/transaksi-penjualan/Index.vue'
  );
const TambahTransaksiPenjualan = () =>
  import(
    /* webpackChunkName: "sc" */ '@/views/stockist-center/penjualan/transaksi-penjualan/Tambah.vue'
  );

const RestockPbs = () =>
  import(
    /* webpackChunkName: "sc" */ '@/views/stockist-center/penjualan/restock-pbs/Index.vue'
  );

// Laporan Penjualan SC
const LaporanPenjualanSC = () =>
  import(
    /* webpackChunkName: "sc" */ '@/views/stockist-center/penjualan/laporan-penjualan-sc/Index.vue'
  );
const TambahLaporanPenjualanSC = () =>
  import(
    /* webpackChunkName: "sc" */ '@/views/stockist-center/penjualan/laporan-penjualan-sc/Tambah.vue'
  );
const CekFaktur = () =>
  import(
    /* webpackChunkName: "admin" */ '@/views/CekFaktur.vue'
  );
const KirimBarangPromoKeStockist = () =>
  import(
    /* webpackChunkName: "sc" */ '@/views/stockist-center/penjualan/kirim-barang-promo/barang-ke-stockist/Index.vue'
  );
const TambahKirimBarangPromoKeStockist = () =>
  import(
    /* webpackChunkName: "sc" */ '@/views/stockist-center/penjualan/kirim-barang-promo/barang-ke-stockist/Tambah.vue'
  );

let root = '/penjualan';

export default [
  {
    path: root + '/',
    component: Dashboard,
    meta: {
      auth: true,
      title: 'Dashboard | Penjualan Pusat',
      layout: LayoutDefault,
    },
  },
  {
    path: root + '/cek-faktur',
    component: CekFaktur,
    meta: {
      auth: true,
      title: 'Cek Faktur',
      layout: LayoutDefault,
    },
  },
  {
    path: root + '/transaksi-penjualan/',
    component: LayoutData,
    meta: {
      breadcrumb: 'Transaksi Penjualan',
    },
    children: [
      {
        path: '',
        component: TransaksiPenjualan,
        name: 'penjualan',
        meta: {
          auth: true,
          title: 'Transaksi Penjualan | Penjualan Pusat',
          layout: LayoutDefault,
        },
      },
      {
        path: 'tambah-transaksi-penjualan',
        component: TambahTransaksiPenjualan,
        name: 'penjualan.tambah',
        meta: {
          auth: true,
          title: 'Tambah Transaksi Penjualan | Penjualan Pusat',
          layout: LayoutDefault,
          breadcrumb: 'Tambah Transaksi Penjualan',
        },
      },
      {
        path: ':id',
        component: TambahTransaksiPenjualan,
        name: 'penjualan.edit',
        meta: {
          auth: true,
          title: 'Edit Transaksi Penjualan | Penjualan Pusat',
          layout: LayoutDefault,
        },
      },
    ],
  },
  {
    path: root + '/restock-pbs/',
    component: RestockPbs,
    meta: {
      auth: true,
      title: 'Restock P3S | Penjualan Pusat',
      layout: LayoutDefault,
      breadcrumb: 'Restock P3S',
    }
  },
  {
    path: root + '/laporan-penjualan-sc/',
    component: LayoutData,
    meta: {
      breadcrumb: 'Laporan Penjualan SC',
    },
    children: [
      {
        path: '',
        component: LaporanPenjualanSC,
        name: 'laporan-penjualan-sc',
        meta: {
          auth: true,
          title: 'Laporan Penjualan SC | Gudang',
          layout: LayoutDefault,
        },
      },
      {
        path: 'tambah-laporan-penjualan-sc',
        component: TambahLaporanPenjualanSC,
        name: 'laporan-penjualan-sc.tambah',
        meta: {
          auth: true,
          title: 'Tambah Laporan Penjualan SC | Gudang',
          layout: LayoutDefault,
          breadcrumb: 'Tambah Laporan Penjualan SC',
        },
      },
    ],
  },
  {
    path: root + '/kirim-promo/',
    component: LayoutData,
    meta: {
      breadcrumb: 'Kirim Promo',
    },
    children: [
      {
        path: 'tambahan-stockist',
        component: KirimBarangPromoKeStockist,
        name: 'penjualan.kirim-barang-promo.ke-stockist',
        meta: {
          auth: true,
          title: 'Tambahan Barang Promo di Luar Promo ke Stockist | Penjualan SC',
          layout: LayoutDefault,
          breadcrumb: 'Kirim Promo',
        },
      },
      {
        path: 'tambahan-stockist/tambah',
        component: TambahKirimBarangPromoKeStockist,
        name: 'penjualan.kirim-barang-promo.ke-stockist.tambah',
        meta: {
          auth: true,
          title: 'Kirim Tambahan Barang Promo ke Stockist | Penjualan SC',
          layout: LayoutDefault,
          breadcrumb: 'Kirim Tambahan Barang Promo ke Stockist',
        },
      },
    ]
  },
];
